import { PDFViewer } from '@carboledger/ui';
import { useTranslations } from '@/hooks';
import styles from './PdfPreviewPanel.module.scss';

/**
 * Props:
 *   fileUrl  the declaration's attachment URL, when one is known
 */
export const PdfPreviewPanel = ({ fileUrl }) => {
  const t = useTranslations();

  return (
    <div className={styles.panel}>
      <PDFViewer
        className={styles.viewer}
        file={fileUrl}
        showToolbar={false}
        showSidebar={false}
        fitToWidth
        noFileLabel={t('PDF_VIEWER_NO_FILE')}
      />
    </div>
  );
};
